import React from 'react'

interface Props {
  width: string
  height: string
  fill: string
}

const IconArrowsRepeatCircle = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg width={width} height={height} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
      <g>
        <circle fill={fill} opacity={0.3} cx='12' cy='12' r='10' />
        <path
          fill={fill}
          d='M6.808,14.713a.755.755,0,0,1,.162-.243l1.5-1.5a.75.75,0,0,1,1.06,1.06l-.219.22H15a.751.751,0,0,0,.75-.75V12a.75.75,0,0,1,1.5,0v1.5A2.253,2.253,0,0,1,15,15.75H9.311l.219.22a.75.75,0,1,1-1.06,1.06l-1.5-1.5a.751.751,0,0,1-.162-.817ZM6.75,10.5V12a.75.75,0,0,0,1.5,0V10.5A.751.751,0,0,1,9,9.75h5.689l-.219.22a.75.75,0,1,0,1.06,1.06l1.5-1.5a.751.751,0,0,0,0-1.06l-1.5-1.5a.75.75,0,0,0-1.06,1.06l.219.22H9A2.253,2.253,0,0,0,6.75,10.5Z'
        />
      </g>
    </svg>
  )
}

export default IconArrowsRepeatCircle
